import {AppBox, AppContainer, AppPaginator} from "../../../commons/components";
import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks/app";
import {Outlet, useParams} from "react-router";
import TournamentList from "./components/TournamentList";
import {setPageTitle} from "../../../redux/slices/page-title-slice";
import {
    cleanUpManageCompetitionList,
    fetchManageCompetitionList,
} from "../../../redux/slices/football/admin/competition/manage-competition-list-slice";

import usePagination from "../../../hooks/usePagination";
import useFilter from "../../../hooks/useFilter";

export default function TournamentManage() {
    const {competitionId} = useParams();
    const dispatch = useAppDispatch();
    const {competitionList} = useAppSelector((state) => state.footballManageCompetitionList);
    const {page, pageChange, pageLimitChange, perPage} = usePagination();
    const {sortOrder, searchText, sortBy} = useFilter();

    useEffect(() => {
        dispatch(setPageTitle("Tournaments"));
        return () => {
            dispatch(cleanUpManageCompetitionList());
        };
    }, []);

    useEffect(() => {
        dispatch(fetchManageCompetitionList({sort: sortBy, sortOrder, name: searchText, page, perPage}));
    }, [perPage, page, sortBy, sortOrder, searchText]);

    return (
        <>
            {competitionId ? (
                <Outlet/>
            ) : (
                <AppContainer>
                    <AppBox py="md" flexDirection="column" gap="md">
                        <TournamentList/>
                        {competitionList.pageCount > 1 &&
                            <AppPaginator perPage={competitionList?.perPage}
                                          pageCount={competitionList?.pageCount}
                                          currentPage={competitionList?.page}
                                          pageChange={pageChange}
                                          perPageLimitChange={pageLimitChange}
                            />
                        }
                    </AppBox>
                </AppContainer>
            )}
        </>
    );
}
